import { Lookup } from '@shared/providers/src/DropdownOptionsProvider'
import { isEscalationTask, isMATask, isProviderTask, isSupportTask, UserRole } from '@shared/utils'

import { hasDoneReasons } from '@hooks/useTaskDoneReasons'

export const isTaskClickable = (me, task) => {
  if ([UserRole.MA, UserRole.Admin].includes(me.role) && isMATask(task)) return true
  if ([UserRole.Support, UserRole.Admin].includes(me.role) && isSupportTask(task)) return true
  if (me.role === UserRole.Provider && isProviderTask(task) && task.assignee?.id === me.id) return true
  if (me.role === UserRole.Admin && isEscalationTask(task)) return true
  return false
}

export const getTaskType = (types, task) => {
  let type = types[task.kind] || task.kind
  if (hasDoneReasons(task.kind) && isMATask(task)) {
    type = [type, task.reason].filter(Boolean).join(' – ')
  }
  return type
}

export const getTasks = (role) => {
  if (role === UserRole.MA) return Lookup.MATasks
  if (role === UserRole.Support) return Lookup.CSTasks
  if (role === UserRole.Provider) return Lookup.ProviderTasksForMA
  return ''
}
